var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-message"},[_vm._v("\n    Your account is still provisioning."),_c('br'),_vm._v("This might take a while...\n    "),_c('br'),_c('br'),_vm._v("If the app doesn't show up soon, please perform a browser refresh.\n  ")])])
}]

export { render, staticRenderFns }